export default __webpack_public_path__ + "static/media/Simran Dhankar.df179973.jpeg";